<template>
    <div class="row">
        <auction-card v-for="auction in auctions" :key="auction.id" :auction="auction"/>
    </div>
</template>

<script>
    import AuctionCard from "./AuctionCard.vue";

    export default {
        components: {AuctionCard},
        props: ['auctions'],
    };
</script>
